import { createStyles, makeStyles } from "@material-ui/core/styles";
import illustrator_nothing from "assets/images/illustrator_paps.png";
import useText from "constants/text";
import { PromoImage } from "domains/CashManagement/data/icons";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      justifyItems: "center",
      height: "92vh",
      width: "100%",
      margin: theme.spacing(0.2),
      backgroundColor: "#fff",
      padding: theme.spacing(1.5),
    },
    first: {
      color: "#abd6e4",
      fontSize: 36,
    },
    second: {
      fontWeight: 900,
      color: "#57adc8",
      fontSize: 36,
    },
    illustrator: {
      background: `url(${illustrator_nothing})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      height: "40%",
      width: "100%",
    },
    promo: {
      marginTop: "2vh",
    },
  })
);

export function DefaultInfo() {
  const styles = useStyles();
  const { text } = useText();
  return (
    <div className={styles.promo}>
    <div className={styles.root}>
      <div className={styles.first}>{text.all.your_parcels}</div>
      <div className={styles.second}>{text.all.anytime_anywhere}</div>
      <div className={styles.illustrator} />
    </div> 
      {/* 
       @TODO : decommente code when needed
      <PromoImage width="100%" height="87vh" /> */}
    </div>
  );
}
